import { mdlClaimAttachments } from "./CompAttachmentsMdl";

export class mdlClaimBindInfoRes {
    public CityList: Array<mdlCity> = new Array<mdlCity>();
    public Policies: Array<PoliciesMdl> = new Array<PoliciesMdl>();
    public Liability: Array<LiabilityMdl> = new Array<LiabilityMdl>();
    public ClaimTypeList: Array<ClaimTypeListMdl> = new Array<ClaimTypeListMdl>();
    public bankList: Array<BankMasterMdl> = new Array<BankMasterMdl>();
    public EstimationTypeList: Array<EstimationTypeListMdl> = new Array<EstimationTypeListMdl>();
    public ClaimAttachmentList: Array<mdlClaimAttachments> = new Array<mdlClaimAttachments>();
    public AttachmentId: string
    public StatusCode: string
    public StatusDesc: string
    public BankCode: string;
}
export class mdlGetClaimsListReq {
    public RegNo: string;
}
export class LiabilityMdl {
    public Liability: number;
}
export class PoliciesMdl {
    public Policy: string;
    public IbanNumber: string;
}
export class ClaimTypeListMdl {
    public ClaimType: string;
    public ClaimTypeCode: number;
    public ClaimTypeDesc_En: string;
    public ClaimTypeDesc_Ar: string;
}
export class CityMdl {
    public CityCode: number;
    public CityNameEn: string;
    public CityNameAr: string;
    public RegCode: string;
    public RegDescEn: string;
    public RegDescAr: string;
}
export class BankMasterMdl {
    public BankCode: string;
    public BankDesc_Eng: string;
    public BankDesc_Ar: string;
    public CbidCode: string;
    // isSameCode: boolean;
}
export class mdlClaimType {
    public ClaimTypeCode: number;
    public ClaimTypeDesc_En: string;
    public ClaimTypeDesc_Ar: string;
}
export class EstimationTypeListMdl {
    public EstimationTypeCode: number;
    public EstimationTypeDesc_Ar: string;
    public EstimationTypeDesc_En: string;
}
export class mdlCity {
    public CityCode: number;
    public CityDesc_En: string;
    public City_Ar: string;
}
export class mdlEstimationType {
    public EstimationTypeCode: number;
    public EstimationTypeDesc_En: string;
    public EstimationTypeDesc_Ar: string;
}

export class mdlClaimIntimationAddReq {
    public RegNo: string
    public PolicyNo: string
    public AccidentDate: string
    public ClaimTypeCode: number
    public Liability: number
    public AccidentCityCode: number
    public ClaimCityCode: number
    public TaqdeerNumber: string
    public NajmId: string
    public EstimatedAmount: number
    public IbanNo: string;
    public BankCode: number
    public EstimationTypeCode: number
    public Attachments: Array<Attachments> = new Array<Attachments>();
    public AccReportFileName: string;
    public IBANFileName: string;

    public ProductCode: string;
    public FirstName: string;
    public LastName: string;
    public MobileNumber: string;
    public Email: string;
    public PlateNumber: string;
    public IDNumber: string;
    public AccidentOrCaseNumber: string;
    public AccidentResPer: number;
    public RepairType: string;
    public SequenceNo: string;

    public DriverName: string;
    public DriverAge: number;
    public DriverMobileNumber: string;
    public DriverLicenseExpiry: string;
    public UserId: string;
    public Channel: string;
    public Lang: string;


}
export class Attachments {
    public ComplaintId: string
    public Attachment: string;
}
export class mdlClaimIntimationAddRes {
    public ClaimIntimationNo: string;
    public StatusCode: string
    public StatusDesc: string
    public MobileNo: string
    public EmailId: string
    public Template: string
    public SmsStatus: string
    public EmailStatus: string
    public Lang: string
}
export class mdlClaimIntimationListRes {
    public PolicyNo: string;
    public IDNumber: string;
    public FirstName: string;
    public LastName: string;
    public MobileNumber: string;
    public Email: string;
    public PlateNumber: string;

    public ClaimIntimationNo: string
    public AccidentDate: Date;
    public ClaimTypeDesc_En: string;
    public ClaimTypeDesc_Ar: string;
    public Liability: number;
    public AccidentCity_En: string;
    public AccidentCity_Ar: string;
    public ClaimCity_En: string
    public ClaimCity_Ar: string
    public TaqdeerNumber: string
    public NajmId: string
    public EstimatedAmount: string
    public IbanNo: string
    public EstimationTypeDesc_En: string;
    public EstimationTypeDesc_Ar: string
    public Attachments: Array<Attachments> = new Array<Attachments>();
    public StatusCode: string;
    public StatusDesc: string;
}

export class mdlClaimStatusReq {
    public PolicyNo: string;
    public SequenceNo: string;
    public InsuredIdNo: string;
    public CHASSIS_NO: string;
    public INSURED_MOBILE_NO: string;
    public THIRD_PARTY_ID: string;
    public THIRD_PARTY_MOBILE_NO: string;
    public THIRD_PARTY_PLATE_NO: string;
    public NAJM_CASE_NUMBER: string;
    public CLAIM_NO: string;
}
export class mdlClaimStatusNewReq {
    public ParameterKey: string;
    public ParameterValue: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/Claims.ts